let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("diXnR"), load("kXcA7")]).then(() => parcelRequire('bAPy4'));